// extracted by mini-css-extract-plugin
export default {"cookies_container":"cookies_cookies_container__Gl1es","button_selected":"cookies_button_selected__tkj1i"};